import * as React from "react";
import { FilterQuery } from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { AvailableFilterOptions, Filter } from "./filter";

export type AppliedFilterControlsProps = {
  appliedFilter: FilterQuery;
  filterOptions: AvailableFilterOptions;
  onRemove: (newFilter: FilterQuery) => void;
  availableFilters: Filter[];
};

export const AppliedFilterControls = React.memo(
  ({
    appliedFilter,
    filterOptions,
    onRemove,
    availableFilters,
  }: AppliedFilterControlsProps): JSX.Element => (
    <>
      {availableFilters.map((filter) => (
        <filter.AppliedControlComponent
          key={filter.key}
          appliedFilter={appliedFilter}
          filterOptions={filterOptions}
          onRemove={onRemove}
        />
      ))}
    </>
  )
);
